import React, { Suspense } from 'react'
import { Loader2 } from 'lucide-react'

const LazyPage = ({ children }: { children: React.ReactNode }) => (
 <Suspense
 fallback={
 <div className="flex items-center justify-center min-h-[50vh]">
 <Loader2 className="animate-spin"/>
 </div>
 }
 >
 {children}
 </Suspense>
)

export default LazyPage
